import { AgentId } from './agents';

export interface SurveyKey {
  projectId: string;
  agentId: AgentId;
}

export function sameSurveyKey(
  surveyKey1: SurveyKey | undefined,
  surveyKey2: SurveyKey | undefined
): boolean {
  if (!surveyKey1 || !surveyKey2) {
    return false;
  }
  return (
    surveyKey1 === surveyKey2 ||
    (surveyKey1.projectId === surveyKey2.projectId &&
      surveyKey1.agentId === surveyKey2.agentId)
  );
}

export interface Survey {
  id: string;
  title: string;
  description?: string;
  questions: SurveyQuestion[];
  intended_agent: AgentId;
}

export interface SurveyQuestion {
  id: number;
  text: string;
  type: number;
  options?: SurveyQuestionOption[];
  input_box_default_text?: string;
  text_input_type: SurveyTextType;
  minimum_selected_options?: number;
  maximum_selected_options?: number;
  is_required: boolean;
}

export enum SurveyQuestionType {
  TEXT = 0,
  CHOICE = 1,
  CHOICE_AND_TEXT = 2,
}

export interface SurveyQuestionOption {
  id: number;
  text: string;
  label?: string;
  label_color?: string;
  input_box_default_text?: string;
  text_input_type: SurveyTextType;
}

export enum SurveyTextType {
  NONE = 0,
  MANDATORY = 1,
  OPTIONAL = 2,
}
